const NAVIGATE_DELAY = 150; //ms

const Navigation = {
    delayNavigateTo(event, { stripDomain = false } = {}) {
        event.preventDefault();

        const targetUrl = event.currentTarget.getAttribute("href");
        Navigation.delayNavigateToUrl(targetUrl, { stripDomain });
    },

    delayNavigateToUrl(url, { stripDomain = false } = {}) {
        let targetUrl = url;
        if (stripDomain) {
            targetUrl = Navigation.stripDomainFromUrl(targetUrl);
        }

        setTimeout(() => Navigation._navigateTo(targetUrl), NAVIGATE_DELAY);
    },

    navigateToWithoutHistory(url) {
        window.location.replace(url);
    },

    stripDomainFromUrl(url) {
        return url.replace(/https?:\/\/[^/]+/i, "");
    },

    _navigateTo(url) {
        window.location.href = url;
    },
};

export default Navigation;

export const {
    delayNavigateTo,
    delayNavigateToUrl,
    navigateToWithoutHistory,
    stripDomainFromUrl,
    _navigateTo,
} = Navigation;
